import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIntake = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "intake",
	"data-name": "intake",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M10.08.5V6.76A3.81,3.81,0,0,1,8,10.18H8a3.81,3.81,0,0,1-3.42,0h0A3.81,3.81,0,0,1,2.42,6.76V.5"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 6.25,
			y1: .5,
			x2: 6.25,
			y2: 23.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M21.58,7.21a3.83,3.83,0,1,1-7.66,0c0-2.12,1.71-5.75,3.83-5.75S21.58,5.09,21.58,7.21Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 17.75,
			y1: 23.5,
			x2: 17.75,
			y2: 11.04
		})
	]
});
const ForwardRef = forwardRef(SvgIntake);
export default ForwardRef;
